import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { useMe } from "@/lib/me";

export default function MockPayPage() {
  const { id } = useParams();
  const api = useApi();
  const me = useMe();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const act = async (berjaya) => {
    setBusy(true);
    try { await api("post", `/billing/mock/${id}/pay`, { berjaya }); me?.refresh(); nav(`/akaun?bayaran=${id}`); }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="surface rounded-2xl p-8 space-y-5 text-center" data-testid="mock-pay-page">
        <div className="eyebrow !text-warn">Mod ujian dalaman</div>
        <h1 className="font-display text-3xl">Simulasi OnPay</h1>
        <p className="text-sm text-mute">Halaman ini menggantikan OnPay sehingga kunci sebenar dimasukkan. Tiada wang sebenar ditolak.</p>
        <div className="flex flex-col gap-3">
          <button onClick={() => act(true)} disabled={busy} data-testid="mock-pay-success" className="h-11 rounded-full bg-ink text-bg font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-40">
            {busy && <Loader2 size={15} className="animate-spin" />} Bayar (ujian)
          </button>
          <button onClick={() => act(false)} disabled={busy} data-testid="mock-pay-fail" className="h-11 rounded-full border border-line text-sm">Batalkan / gagal</button>
        </div>
      </div>
    </div>
  );
}
